export class ActiveProcCodeModel {
    code_no: number
    code_name: string
    code_type: string
    procedure_desc: string

    constructor(
        code_no: number,
        code_name: string,
        code_type: string,
        procedure_desc: string,

    ) {
        this.code_no = code_no
        this.code_name = code_name
        this.code_type = code_type
        this.procedure_desc = procedure_desc
    }
} 